import { useFormInputs } from '@lbcamden/lib-react';
import { FunctionComponent, useEffect, useMemo } from 'react';

import { useReferenceListSelectOptions } from '~/client/hooks/storeHooks';
import { pcfraDetailsSchema } from '~/common/schemas/pcfra';

import { Container } from '../../PcfraCreateEditPage.styled';
import { SectionFormProps } from '../../types';
import { SectionHeading } from '../common.styled';
import { detailsFormConfig, DetailsFormValues } from './config';

export const Details: FunctionComponent<SectionFormProps> = ({
  draftValues,
  showErrors,
  onChange,
}) => {
  const referenceListSelectOptions = useReferenceListSelectOptions();

  const config = useMemo(
    () => detailsFormConfig(referenceListSelectOptions),
    [referenceListSelectOptions],
  );

  const {
    formState: { data },
    formInputs,
  } = useFormInputs<DetailsFormValues>({
    config,
    schema: pcfraDetailsSchema,
    value: draftValues?.details as DetailsFormValues,
    showErrors,
  });

  useEffect(() => {
    onChange({ details: data });
  }, [data]);

  return (
    <Container>
      <SectionHeading>Initial details</SectionHeading>
      {formInputs}
    </Container>
  );
};
